export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";
export const TOGGLE_INSTA_ORDER_CREATE_MODAL = "TOGGLE_INSTA_ORDER_CREATE_MODAL";
export const TOGGLE_INSTA_BULK_ORDER_MODAL = "TOGGLE_INSTA_BULK_ORDER_MODAL";
export const TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL = "TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL";
